import { mergeClassNames } from "@bokio/utils/classes";

import type { FC, ReactNode } from "react";

import * as styles from "./labelFor.scss";

interface LabelProps {
	label: ReactNode;
	hint?: ReactNode;
	className?: string;
	/**
	 * Marks the field that the label is for as required by adding an asterisk (*) next to the label
	 */
	markAsRequired?: boolean;
}

export const Label: FC<LabelProps> = ({ label, hint, className, markAsRequired = false }) => {
	return (
		<div className={mergeClassNames(styles.floating, className)}>
			{label}
			{markAsRequired && <span className={styles.required}> *</span>}
			{hint && <small className={styles.hint}>{hint}</small>}
		</div>
	);
};
